module.exports = __webpack_public_path__ + "img/presentations.328cd23d.jpg";